<template>
  <div>
    <van-overlay className="loading-common" :show="show" :zIndex="zIndex">
      <div class="wrapper">
        <van-loading color="#4281ef" />
      </div>
    </van-overlay>
  </div>
</template>
<script>
export default {
  name: "LoadingCommon",
  props: ["show", "zIndex"]
};
</script>
<style lang="scss">
.loading-common {
  opacity: 0.6;
  .wrapper {
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    transform: translate(-50%);
  }
}
</style>
